import { useAPIPublic } from "./tools/api";
import { CheckToken, setToken } from "./tools/services";

export const InitialApp = () => {
  const { createApiTokenBySession } = useAPIPublic();
  return new Promise(async (resolve, reject) => {
    try {
      const validToken = await CheckToken();
      if (!validToken) {
        let param = {
          captcha: process.env.REACT_APP_CAPTCHA,
        };
        let responseToken = await createApiTokenBySession(param);
        if (responseToken) {
          await setToken(responseToken);
          resolve(true);
          return;
        } else {
          resolve(false);
          return;
        }
      }
      resolve(true);
    } catch (error) {
      reject(error);
    }
  });
};
